import { TimePicker } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import './timepickerStyles.css';

function AnimatedTimePicker({ label, value, handleTimeChange, isMandatory, inputId, isDisabled, disabled, placeholder, style, width, inputstyle, inputReadOnly, disabledHours, disabledMinutes, allowClear, format }) {
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        if (value) {
            document.getElementById(`customInputLabel_${inputId}`).classList.add('shrink');
        }
    }, [value, inputId]);

    const handleInputFocus = () => {
        setIsFocused(true);
        document.getElementById(`customInputLabel_${inputId}`).classList.add('shrink');
    };

    const handleInputBlur = () => {
        setIsFocused(false);
        if (!value) {
            document.getElementById(`customInputLabel_${inputId}`).classList.remove('shrink');
        }
    };

    return (
        <div className="custom-input-container m-t-20" style={style}>
            <label htmlFor={`customInput_${inputId}`} id={`customInputLabel_${inputId}`} className={`custom-input-label ${value ? 'shrink' : ''}`} >
                {label}{" "} {isMandatory ? <span style={{ color: 'red' }}>*</span> : <></>}
            </label>
            <TimePicker
                bordered={null}
                id={`customInput_${inputId}`}
                style={{ 
                    color: "#636363", 
                    fontSize: 14, 
                    backgroundColor: isFocused ? "#F6F4FE" : "#FFFFFF", 
                    width: width ? width : "100%", 
                    marginLeft: -12,
                    ...inputstyle, 
                }}
                format={format}
                placeholder={placeholder || ""}
                onChange={handleTimeChange}
                value={value ? moment(value, 'HH:mm') : null}
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
                disabled={isDisabled || disabled}
                inputReadOnly={inputReadOnly}
                allowClear={allowClear || false}
                disabledHours={disabledHours}
                disabledMinutes={disabledMinutes}
            />
            <div style={{ borderBottom: '1px solid #8C8C8C' }}></div>
        </div>
    );
}

export default AnimatedTimePicker;
